export default __webpack_public_path__ + "assets/images/spades.647c1b1168f420c84d0d7be3c4117d1d.png";